import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { isProd } from '@telialt/utils/src/helpers';

import { getSdkKey } from '../getSdkKey';

export const USER_GROUP_KEYS = {
    POP: 'popgroup',
    SIM_TERMINATION: 'simterminationgroup',
    UO_AUTO_ORDER_GROUP: 'uoautoordergroup',
    FIX_INTERNET_AUTO_ORDER_GROUP: 'fixinternetautoordergroup',
    F_SECURE: 'fsecuregroup',
    ROAMING_TARIFFS: 'roamingtariffsgroup',
    HIGHLIGHTING_VAS: 'highlightingvasgroup',
    NETFLIX_VAS_GROUP: 'netflixvasgroup',
    DISNEY_VAS_GROUP: 'disneyvasgroup',
    ESHOP_NBO_USERS_GROUP: 'eshopnbooffersgroup',
};

export const FLAG_KEYS = {
    DISABLE_EQUIPMENT_PAGE: 'disable_equipment_page',
    ENABLE_RATE_PLAN_PAGE_NOTIFICATION: 'enable_rate_plan_page_notification',
    ENABLE_TELIA1_POPUP: 'enable_telia1_popup',
    PAYMENT_OLD_BANKLINK: 'payment_old_banklink',
    DISABLE_MOBILE_ID_PRICE: 'disable_mobile_id_price',
    ENABLE_TOP_UP_MAINTENANCE_MODE: 'enable_top_up_maintenance_mode',
    DISABLE_PENDING_DOCUMENTS_CHECK_DASHBOARD: 'disable_pending_documents_check',
    DISABLE_PENDING_DOCUMENTS_CHECK_NAVBAR: 'disable_pending_documents_check_navbar',
    ENABLE_HUDSON_INSTALLMENTS: 'enable_hudson_installments',
    ENABLE_UO_FOR_SS: 'enable_uo_for_ss',
    ENABLE_SIM_CARD_ACTIVATION: 'enable_sim_card_activation',
    ENABLE_CSV_REPORT: 'enable_csv_report',
    ENABLE_SIM_CARD_TERMINATION: 'enable_sim_card_termination',
    ENABLE_MOBILE_APP_PROMOTION_BANNER: 'enable_mobile_app_promotion_banner',
    ENABLE_PRICE_DISCOUNT_DISPLAY: 'enable_price_discount_display',
    ENABLE_MBB_PLAN_CHANGE_4G_TO_5G_MODAL: 'enable_mbb_plan_change_4g_to_5g_modal',
    ENABLE_UO_AUTO_ORDER_PLAN_CHANGE: 'enable_uo_auto_order_plan_change',
    ENABLE_FWA_PLAN_CHANGE: 'enable_fwa_plan_change',
    ENABLE_TV_PLAN_CHANGE: 'enable_tv_plan_change',
    ENABLE_FIX_INTERNET_AUTO_ORDER_PLAN_CHANGE: 'enable_fix_internet_auto_order',
    ENABLE_B2B_INVOICE_TEMPLATE_NOTIFICATION: 'enable_b2b_invoice_template_notification',
    ENABLE_F_SECURE: 'enable_f_secure',
    ENABLE_ESIM_ORDERING: 'enable_esim_ordering',
    ENABLE_ROAMING_TARIFFS: 'enable_roaming_tariffs',
    ENABLE_ESIM_QR_CODE_DOWNLOAD: 'enable_esim_qr_code_download',
    ENABLE_FIX_DIAGNOSTICS: 'enable_fix_diagnostics',
    ENABLE_ORDER_TV_DISPLAY_IN_CHECKOUT: 'enable_order_tv_display_in_checkout',
    ENABLE_PROACTIVE_INVOICE_CONTACT_DATA_UPDATE: 'enable_proactive_invoice_contact_data_update',
    ENABLE_NEW_MHS_MBB_PLAN_SELECTION_PAGE: 'enable_new_mhs_mbb_plan_selection_page',
    ENABLE_HT_PLAN_CHANGE: 'enable_ht_plan_change',
    ENABLE_NETFLIX_ADDITIONAL_SERVICE: 'enable_netflix_additional_service',
    ENABLE_TECHNOLOGY_CHANGE_DISPLAY: 'enable_technology_change_display',
    ENABLE_DISNEY_ADDITIONAL_SERVICE: 'enable_disney_additional_service',
    ENABLE_ROAMING_LIMITS_SETTINGS: 'enable_roaming_limits_settings',
    ENABLE_REMOVE_ROAMING_LIMITS_FOR_RCC_LIMITS: 'enable_remove_limits_for_rcc_limits',
    ENABLE_ESHOP_NBO_OFFERS: 'enable_eshop_nbo_offers',
    ENABLE_MOBILITY_INCIDENTS_MAP_LINK: 'enable_mobility_incidents_map_link',
};

export const DISPATCHED_OPT_EVENTS = 'dispatchedOptEvents';

const getLogLevel = () => {
    const isTest = process.env.NODE_ENV === 'test';
    if (isTest) {
        return null;
    }
    if (isProd()) {
        return 'error';
    }

    return 'info';
};
export const commonOptimizelyConfig = {
    eventBatchSize: 10,
    eventFlushInterval: 1000,
    logLevel: getLogLevel(),
};

export const dynamicConfig = {
    sdkKey: getSdkKey(),
    datafileOptions: {
        autoUpdate: true,
        updateInterval: 300000, // 5 minutes in milliseconds
        urlTemplate: 'https://optimizely.my.telia.lt/datafiles/%s.json',
    },
    ...commonOptimizelyConfig,
};

export const API = {
    URL_CUSTOMER_SETTINGS_GROUPS: '/api/v1/b2c/customer/groups',
    URL_CUSTOMER_SETTINGS_BASIC: '/api/v1/b2c/customer/basic',
    URL_DATA_FILE: 'https://optimizely.my.telia.lt/datafiles/{sdkKey}.json',
};

if (checkShouldUseMocks()) {
    API.URL_CUSTOMER_SETTINGS_GROUPS = '/api/customer/groups';
    API.URL_CUSTOMER_SETTINGS_BASIC = '/api/customer/basic';
}

export const SS_QUERY_KEY = {
    CUSTOMER_SETTINGS_GROUPS: 'customer-settings-groups',
    CUSTOMER_SETTINGS_BASIC: 'customer-settings-basic',
    OPTIMIZELY_DATAFILE: 'optimizely-datafile',
};
